<script lang="ts" setup>
  import { ref, type PropType, onUpdated, onMounted, type Ref, onBeforeUpdate, onBeforeUnmount } from 'vue';
  import Swiper from 'swiper';
  import { Navigation } from 'swiper/modules';
  import 'swiper/css';
  import 'swiper/css/autoplay';
  import 'swiper/css/pagination';
  import type { Photo } from '@storefront/resources';
  import type { NavButtons } from '@storefront/types';

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    header: { type: String },
    headerType: { type: String },
    content: { type: String },
    photos: { type: Array as PropType<Photo[]>, required: true },
  });

  const htmlNavigation = ref() as Ref<NavButtons>;
  const htmlElement = ref() as Ref<HTMLElement>;
  const swiper = ref() as Ref<Swiper>;

  function initializeSwipers() {
    swiper.value = new Swiper(htmlElement.value, {
      modules: [Navigation],
      loop: true,
      pagination: true,
      breakpoints: {
        1: {
          slidesPerView: 2.5,
          spaceBetween: 10,
          slidesOffsetBefore: 10,
          slidesOffsetAfter: 10,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 16,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
      navigation: {
        nextEl: htmlNavigation.value.next.htmlElement,
        prevEl: htmlNavigation.value.prev.htmlElement,
      },
    });
  }

  function destroySwipers() {
    swiper.value?.destroy();
  }

  onMounted(() => {
    initializeSwipers();
  });

  onBeforeUpdate(() => {
    destroySwipers();
  });

  onUpdated(() => {
    initializeSwipers();
  });

  onBeforeUnmount(() => {
    destroySwipers();
  });
</script>
<template>
  <SfSection class="photo-slider-block" :title="header" :headerType>
    <QuillContent v-if="content" :content />
    <div class="items-carousel">
      <div ref="htmlElement" class="swiper photo-slider-block__swiper">
        <div class="swiper-wrapper">
          <div v-for="photo in photos" class="swiper-slide">
            <MediaPicture :photo type="photo" sizes="588x442 2x max 768, 294x221 max 768, 870x652 2x, 435x326" />
          </div>
        </div>
        <div class="swiper-pagination" />
      </div>
      <SfCarouselButtons ref="htmlNavigation" />
    </div>
  </SfSection>
</template>
